export default __webpack_public_path__ + "static/media/timeline.42763eb9.jpg";